import React from 'react';
import PropTypes from 'prop-types';
import StatusPage from '../../components/StatusPage/StatusPage';

const Pending = ({ children }) => (
  <StatusPage icon="fas fa-bed" accentColor="#e1f2fe">
    {children}
  </StatusPage>
);

Pending.defaultProps = {
  children: 'Your enrollment is currently pending. Please check back later.',
};

Pending.propTypes = {
  children: PropTypes.node,
};

export default Pending;
